import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

// Chiusura del flusso con dati inseriti: chiede conferma
@Component({
  selector: 'ord-new-customer-exit-dialog',
  imports: [MatButtonModule, MatDialogModule],
  template: `
    <h2 mat-dialog-title class="title-medium-emphasized">Vuoi interrompere la creazione del cliente?</h2>
    <mat-dialog-content>
      <span class="body-medium">I dati inseriti finora andranno persi.</span>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton type="button" [mat-dialog-close]="false">Annulla</button>
      <button matButton="filled" type="button" [mat-dialog-close]="true">Sì, chiudi</button>
    </mat-dialog-actions>
  `,
})
export class NewCustomerExitDialog {}
